import { Text, View } from 'react-native';
import { Button } from './Button';

type AccountConnectionActionsProps = {
  onConnectAccount: () => void;
  onAddManualAccount: () => void;
  onConnectBrokerage?: () => void;
  connectAccountLoading?: boolean;
  connectBrokerageLoading?: boolean;
  showBrokerageFallback?: boolean;
  disabled?: boolean;
  className?: string;
};

export function AccountConnectionActions({
  onConnectAccount,
  onConnectBrokerage,
  onAddManualAccount,
  connectAccountLoading = false,
  connectBrokerageLoading = false,
  showBrokerageFallback = false,
  disabled = false,
  className = '',
}: AccountConnectionActionsProps) {
  const hasBrokerageFallback = showBrokerageFallback && typeof onConnectBrokerage === 'function';
  const isBusy = connectAccountLoading || (hasBrokerageFallback && connectBrokerageLoading);
  const actionsDisabled = disabled || isBusy;
  const brokeragePressHandler = actionsDisabled ? undefined : onConnectBrokerage;

  return (
    <View className={`mt-3 gap-3 ${className}`}>
      <Button
        testID="accounts-connect-plaid-button"
        accessibilityLabel="Connect a Plaid account"
        onPress={onConnectAccount}
        loading={connectAccountLoading}
        disabled={actionsDisabled}
      >
        Connect an account
      </Button>
      <View className="gap-1.5">
        {hasBrokerageFallback ? (
          <Text className="text-xs text-gray-500 dark:text-gray-400">
            Brokerage not available in Plaid?{' '}
            <Text
              testID="accounts-connect-snaptrade-link"
              accessibilityLabel="Connect with SnapTrade"
              className="font-medium text-forest-600 dark:text-forest-500"
              onPress={brokeragePressHandler}
            >
              Connect with SnapTrade
            </Text>
          </Text>
        ) : null}
        <Text className="text-xs text-gray-500 dark:text-gray-400">
          Can't find your institution?{' '}
          <Text
            testID="accounts-add-manual-link"
            accessibilityLabel="Add account manually"
            className="font-medium text-forest-600 dark:text-forest-500"
            onPress={actionsDisabled ? undefined : onAddManualAccount}
          >
            Add it manually
          </Text>
        </Text>
      </View>
    </View>
  );
}
